import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackCTAClick } from '../utils/metaPixel';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const checkoutUrl = 'https://yennilemon.com/cart/44434972934279:1?country=US&locale=es';
  return <AnimatePresence data-id="element-231">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed top-0 left-0 right-0 z-50 bg-sage shadow-md py-3 px-4 md:px-8" data-id="element-232">
          <div className="max-w-6xl mx-auto flex flex-row items-center justify-between" data-id="element-233">
            <div className="hidden md:flex flex-col text-white" data-id="element-234">
              <span className="font-heading font-semibold text-lg" data-id="element-235">
                El Interruptor del Sueño +40
              </span>
              <span className="text-xs opacity-90" data-id="element-236">
                Oferta de lanzamiento termina pronto
              </span>
            </div>

            <div className="flex items-center justify-between w-full md:w-auto gap-4 md:gap-6" data-id="element-237">
              <div className="flex flex-col items-end text-white" data-id="element-238">
                <div className="flex items-center gap-2" data-id="element-239">
                  <span className="text-xs line-through opacity-70" data-id="element-240">
                    $27.00 USD
                  </span>
                  <span className="bg-warm-accent text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full leading-none" data-id="element-241">
                    -75%
                  </span>
                </div>
                <span className="font-bold text-lg leading-none" data-id="element-242">
                  $6.39 USD
                </span>
              </div>

              <a href={checkoutUrl} onClick={trackCTAClick} className="bg-white text-sage font-bold py-2 px-6 rounded-full text-sm md:text-base hover:bg-cream transition-colors shadow-sm whitespace-nowrap" data-id="element-243">
                SÍ, QUIERO DORMIR MEJOR POR $6.39
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}